// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/reporting.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/reporting.proto.
 */
export const file_cortado_v1_reporting: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * CloseRateMetric contains close rate calculation data
 *
 * @generated from message cortado.v1.CloseRateMetric
 */
export type CloseRateMetric = Message<"cortado.v1.CloseRateMetric"> & {
  /**
   * Total number of leads in the period
   *
   * @generated from field: int32 total_leads = 1;
   */
  totalLeads: number;

  /**
   * Number of leads that converted to bookings
   *
   * @generated from field: int32 converted_leads = 2;
   */
  convertedLeads: number;

  /**
   * Close rate as a percentage (0-100)
   *
   * @generated from field: double close_rate_percentage = 3;
   */
  closeRatePercentage: number;
};

/**
 * Describes the message cortado.v1.CloseRateMetric.
 * Use `create(CloseRateMetricSchema)` to create a new message.
 */
export const CloseRateMetricSchema: GenMessage<CloseRateMetric> = /*@__PURE__*/
  messageDesc(file_cortado_v1_reporting, 0);

/**
 * LeadsCountMetric contains lead count data
 *
 * @generated from message cortado.v1.LeadsCountMetric
 */
export type LeadsCountMetric = Message<"cortado.v1.LeadsCountMetric"> & {
  /**
   * Total number of leads in the period
   *
   * @generated from field: int32 total_count = 1;
   */
  totalCount: number;

  /**
   * Breakdown of leads by stage
   *
   * @generated from field: map<string, int32> count_by_stage = 2;
   */
  countByStage: { [key: string]: number };
};

/**
 * Describes the message cortado.v1.LeadsCountMetric.
 * Use `create(LeadsCountMetricSchema)` to create a new message.
 */
export const LeadsCountMetricSchema: GenMessage<LeadsCountMetric> = /*@__PURE__*/
  messageDesc(file_cortado_v1_reporting, 1);

/**
 * RevenuePipelineMetric contains revenue pipeline data
 *
 * @generated from message cortado.v1.RevenuePipelineMetric
 */
export type RevenuePipelineMetric = Message<"cortado.v1.RevenuePipelineMetric"> & {
  /**
   * Total revenue from paid invoices in the period (cents)
   *
   * @generated from field: int64 collected_revenue_cents = 1;
   */
  collectedRevenueCents: bigint;

  /**
   * Total outstanding amount across unpaid/partially-paid invoices (cents)
   *
   * @generated from field: int64 outstanding_revenue_cents = 2;
   */
  outstandingRevenueCents: bigint;

  /**
   * Total value of all invoices in the period (cents)
   *
   * @generated from field: int64 total_pipeline_cents = 3;
   */
  totalPipelineCents: bigint;

  /**
   * Number of invoices in the period
   *
   * @generated from field: int32 invoice_count = 4;
   */
  invoiceCount: number;

  /**
   * Average invoice value (cents)
   *
   * @generated from field: int64 average_invoice_cents = 5;
   */
  averageInvoiceCents: bigint;

  /**
   * Total tips collected in the period (cents). Reported separately —
   * never folded into collected_revenue_cents.
   *
   * @generated from field: int64 tips_collected_cents = 6;
   */
  tipsCollectedCents: bigint;
};

/**
 * Describes the message cortado.v1.RevenuePipelineMetric.
 * Use `create(RevenuePipelineMetricSchema)` to create a new message.
 */
export const RevenuePipelineMetricSchema: GenMessage<RevenuePipelineMetric> = /*@__PURE__*/
  messageDesc(file_cortado_v1_reporting, 2);

/**
 * MonthlyRevenueDataPoint represents revenue data for a single month
 *
 * @generated from message cortado.v1.MonthlyRevenueDataPoint
 */
export type MonthlyRevenueDataPoint = Message<"cortado.v1.MonthlyRevenueDataPoint"> & {
  /**
   * Month label (e.g. "Jan 2026")
   *
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * Year
   *
   * @generated from field: int32 year = 2;
   */
  year: number;

  /**
   * Month (1-12)
   *
   * @generated from field: int32 month = 3;
   */
  month: number;

  /**
   * Revenue collected in this month (cents)
   *
   * @generated from field: int64 collected_cents = 4;
   */
  collectedCents: bigint;

  /**
   * Revenue invoiced in this month (cents)
   *
   * @generated from field: int64 invoiced_cents = 5;
   */
  invoicedCents: bigint;
};

/**
 * Describes the message cortado.v1.MonthlyRevenueDataPoint.
 * Use `create(MonthlyRevenueDataPointSchema)` to create a new message.
 */
export const MonthlyRevenueDataPointSchema: GenMessage<MonthlyRevenueDataPoint> = /*@__PURE__*/
  messageDesc(file_cortado_v1_reporting, 3);

/**
 * RevenueByEventType shows revenue breakdown by event type
 *
 * @generated from message cortado.v1.RevenueByEventType
 */
export type RevenueByEventType = Message<"cortado.v1.RevenueByEventType"> & {
  /**
   * Event type name
   *
   * @generated from field: string event_type = 1;
   */
  eventType: string;

  /**
   * Total revenue from this event type (cents)
   *
   * @generated from field: int64 revenue_cents = 2;
   */
  revenueCents: bigint;

  /**
   * Number of events of this type
   *
   * @generated from field: int32 event_count = 3;
   */
  eventCount: number;
};

/**
 * Describes the message cortado.v1.RevenueByEventType.
 * Use `create(RevenueByEventTypeSchema)` to create a new message.
 */
export const RevenueByEventTypeSchema: GenMessage<RevenueByEventType> = /*@__PURE__*/
  messageDesc(file_cortado_v1_reporting, 4);

/**
 * GetReportingMetricsRequest requests reporting metrics for an organization
 *
 * @generated from message cortado.v1.GetReportingMetricsRequest
 */
export type GetReportingMetricsRequest = Message<"cortado.v1.GetReportingMetricsRequest"> & {
  /**
   * Organization ID to get metrics for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Start date for the reporting period (required)
   *
   * @generated from field: google.protobuf.Timestamp start_date = 2;
   */
  startDate?: Timestamp;

  /**
   * End date for the reporting period (required, exclusive)
   *
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */
  endDate?: Timestamp;
};

/**
 * Describes the message cortado.v1.GetReportingMetricsRequest.
 * Use `create(GetReportingMetricsRequestSchema)` to create a new message.
 */
export const GetReportingMetricsRequestSchema: GenMessage<GetReportingMetricsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_reporting, 5);

/**
 * GetReportingMetricsResponse returns the requested reporting metrics
 *
 * @generated from message cortado.v1.GetReportingMetricsResponse
 */
export type GetReportingMetricsResponse = Message<"cortado.v1.GetReportingMetricsResponse"> & {
  /**
   * Close rate metric data
   *
   * @generated from field: cortado.v1.CloseRateMetric close_rate = 1;
   */
  closeRate?: CloseRateMetric;

  /**
   * Leads count metric data
   *
   * @generated from field: cortado.v1.LeadsCountMetric leads_count = 2;
   */
  leadsCount?: LeadsCountMetric;

  /**
   * The start date used for the query
   *
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp;

  /**
   * The end date used for the query
   *
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp;

  /**
   * Revenue pipeline metrics
   *
   * @generated from field: cortado.v1.RevenuePipelineMetric revenue_pipeline = 5;
   */
  revenuePipeline?: RevenuePipelineMetric;

  /**
   * Monthly revenue trend (up to 12 months)
   *
   * @generated from field: repeated cortado.v1.MonthlyRevenueDataPoint monthly_revenue = 6;
   */
  monthlyRevenue: MonthlyRevenueDataPoint[];

  /**
   * Revenue breakdown by event type
   *
   * @generated from field: repeated cortado.v1.RevenueByEventType revenue_by_event_type = 7;
   */
  revenueByEventType: RevenueByEventType[];
};

/**
 * Describes the message cortado.v1.GetReportingMetricsResponse.
 * Use `create(GetReportingMetricsResponseSchema)` to create a new message.
 */
export const GetReportingMetricsResponseSchema: GenMessage<GetReportingMetricsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_reporting, 6);

/**
 * SalesTaxReportRow represents tax invoiced for a single tax rate.
 *
 * The report is accrual-basis: it covers invoices issued in the period
 * (status Sent or later; Draft and Cancelled are excluded), bucketed by the
 * invoice's issue date. Amounts are after discounts and reflect what was
 * invoiced to customers, not what has been paid.
 *
 * @generated from message cortado.v1.SalesTaxReportRow
 */
export type SalesTaxReportRow = Message<"cortado.v1.SalesTaxReportRow"> & {
  /**
   * Tax rate ID (empty string for items with no tax rate assigned)
   *
   * @generated from field: string tax_rate_id = 1;
   */
  taxRateId: string;

  /**
   * Display name of the tax rate
   *
   * @generated from field: string tax_rate_name = 2;
   */
  taxRateName: string;

  /**
   * Tax rate as a decimal (e.g., 0.0825 for 8.25%)
   *
   * @generated from field: double tax_rate = 3;
   */
  taxRate: number;

  /**
   * Total taxable sales amount (cents): the discounted share of taxable line items
   *
   * @generated from field: int64 taxable_sales_cents = 4;
   */
  taxableSalesCents: bigint;

  /**
   * Total tax invoiced at this rate (cents)
   *
   * @generated from field: int64 tax_collected_cents = 5;
   */
  taxCollectedCents: bigint;

  /**
   * Number of issued invoices containing this tax rate
   *
   * @generated from field: int32 invoice_count = 6;
   */
  invoiceCount: number;
};

/**
 * Describes the message cortado.v1.SalesTaxReportRow.
 * Use `create(SalesTaxReportRowSchema)` to create a new message.
 */
export const SalesTaxReportRowSchema: GenMessage<SalesTaxReportRow> = /*@__PURE__*/
  messageDesc(file_cortado_v1_reporting, 7);

/**
 * GetSalesTaxReportRequest requests a sales tax report for an organization
 *
 * @generated from message cortado.v1.GetSalesTaxReportRequest
 */
export type GetSalesTaxReportRequest = Message<"cortado.v1.GetSalesTaxReportRequest"> & {
  /**
   * Organization ID to get the report for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Start date for the reporting period (required). Interpreted as a calendar
   * date: the instant is rounded to the nearest UTC day, so a client's local
   * midnight selects the intended day in any time zone.
   *
   * @generated from field: google.protobuf.Timestamp start_date = 2;
   */
  startDate?: Timestamp;

  /**
   * End date for the reporting period (required, exclusive). Same calendar-date
   * interpretation as start_date.
   *
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */
  endDate?: Timestamp;
};

/**
 * Describes the message cortado.v1.GetSalesTaxReportRequest.
 * Use `create(GetSalesTaxReportRequestSchema)` to create a new message.
 */
export const GetSalesTaxReportRequestSchema: GenMessage<GetSalesTaxReportRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_reporting, 8);

/**
 * GetSalesTaxReportResponse returns the sales tax report
 *
 * @generated from message cortado.v1.GetSalesTaxReportResponse
 */
export type GetSalesTaxReportResponse = Message<"cortado.v1.GetSalesTaxReportResponse"> & {
  /**
   * Tax breakdown by tax rate
   *
   * @generated from field: repeated cortado.v1.SalesTaxReportRow rows = 1;
   */
  rows: SalesTaxReportRow[];

  /**
   * Total taxable sales across all rows, after discounts (cents)
   *
   * @generated from field: int64 total_sales_cents = 2;
   */
  totalSalesCents: bigint;

  /**
   * Total tax invoiced across all tax rates (cents); always equals the sum of rows
   *
   * @generated from field: int64 total_tax_collected_cents = 3;
   */
  totalTaxCollectedCents: bigint;

  /**
   * Number of distinct issued invoices in the period carrying a taxable line
   *
   * @generated from field: int32 total_invoice_count = 4;
   */
  totalInvoiceCount: number;

  /**
   * The normalized start date used for the query (UTC midnight)
   *
   * @generated from field: google.protobuf.Timestamp start_date = 5;
   */
  startDate?: Timestamp;

  /**
   * The normalized exclusive end date used for the query (UTC midnight)
   *
   * @generated from field: google.protobuf.Timestamp end_date = 6;
   */
  endDate?: Timestamp;
};

/**
 * Describes the message cortado.v1.GetSalesTaxReportResponse.
 * Use `create(GetSalesTaxReportResponseSchema)` to create a new message.
 */
export const GetSalesTaxReportResponseSchema: GenMessage<GetSalesTaxReportResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_reporting, 9);

